<div *ngIf="campaignInfo && show.globalFormsSchema">

    <app-campaign-3-breadcrumb #breadcrumbComponent 
    data-testid="breadcrumbComponent" 
    [arrayBreadcrumbs]="breadcrumbs"
    [campaignTypeName]="campaignTypeName" 
    [campaignTypeDescription]="campaignTypeDescription"
    (onClickBreadcrumb)="breadcrumbClicked($event)"
     homeLink=""></app-campaign-3-breadcrumb>

    <br />
    <!-- Toolbar delle fasi -->
    <kv-phases-toolbar [phases]="campaignPhases" (onClickPhase)="phaseClicked($event)"
        *ngIf="show.phases"></kv-phases-toolbar>

        <!-- Info-base -->
        <div class="infoBaseContainer" [ngClass]="{'formHidden': show.infoBase == false }">
            <app-message-3-info-base
            #infoBaseComponent data-testid="infoBaseComponent"
            [campaignInfo]="campaignInfo"
            [statusMapping]="statusMapping"
            [language]="language"
            [dateFormat]="dateFormat"
            [schemaMode]="schemaMode"
            [comboInizioFruizione]="combos.planning.modalitaInizioFruizione"
            [comboFineFruizione]="combos.planning.modalitaFineFruizione"
            [actionTypesList]="actionTypesList"
            [comboMessageType]="combos.infobase.messageTypes"
            [messageInstanceObject]="messageInstanceObject"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            [ui_mode]="uiModes.infoBase"
            [coupon_mode]="coupon_mode"
            [readOnly]="readOnly"
            (formSchemaChanged)="onFormSchemaChanged($event)"
            (actionTypeChanged)="onActionTypeChanged($event)"
            (enableConfirmButton)="onConfirmButtonEnabled($event)">
          </app-message-3-info-base>
        </div>
        <!-- Pianificazione -->
        <div class="pianificazioneContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.planning == false }">
            <app-message-3-planning
            #planningComponent data-testid="planningComponent"
            [language]="language"
            [dateFormat]="dateFormat"
            [statusMapping]="statusMapping"
            [messageInstanceObject]="messageInstanceObject"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            [formSchema]="globalFormsSchema.properties.pianificazione"
            [campaignInfo]="campaignInfo"
            [ui_mode]="uiModes.planning"
            [readOnly]="readOnly"
            [coupon_mode]="coupon_mode"></app-message-3-planning>
          </div>

                 <!-- FASE 3 - Tipi di azione -->
        <div class="actionTypeContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.actionType == false }">
            <app-message-3-action-type
            #actionTypeComponent data-testid="actionTypeComponent"
            [ui_mode]="uiModes.actionTypes"
            [coupon_mode]="coupon_mode"
            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [couponType]="infoBaseComponent.fieldModel.message_type"
            [readOnly]="readOnly"
            [formSchema]="globalFormsSchema.properties.tipoAzioni"
            [messageInstanceObject]="messageInstanceObject"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
             (actionDynamicChanged)="onActionDynamicChanged($event)"
            ></app-message-3-action-type>
         </div>


     <!-- FASE 4 - Condizioni di emissione -->
         <div class="emissionConditionsContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.emissionConditions == false }">
            <app-message-3-emission-conditions
            #emissionConditionsComponent data-testid="emissionConditionsComponent"
            [language]="language"
            [campaignInfo]="campaignInfo"
            [formSchema]="globalFormsSchema.properties.emissione"
            [dateFormat]="dateFormat"
            [ui_mode]="uiModes.emissionConditions"
            [coupon_mode]="coupon_mode"
            [accumulatorList]="accumulatorListEmission"
            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [messageInstanceObject]="messageInstanceObject"
            [readOnly]="readOnly"
            (anteprimaBarcodeChange)="anteprimaBarcodeChange($event)"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            [isActionDynamic]="isActionDynamic"
            [getProductOnlyBarcodeReady]="getProductOnlyBarcodeReady"

            
            ></app-message-3-emission-conditions>
            </div>


    <!-- FASE 5 - Customer target -->

        <div class="customerTargetContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.customerTarget == false }">
            <app-message-3-customer-target
            #customerTargetComponent data-testid="customerTargetComponent"
            [language]="language"
            [dateFormat]="dateFormat"
            [ui_mode]="uiModes.customerTarget"
            [coupon_mode]="coupon_mode"
            [distributionListEmission]="distributionListEmission"

            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [messageInstanceObject]="messageInstanceObject"
            [readOnly]="readOnly"
            [schemaMode]="schemaMode"
            [formSchema]="globalFormsSchema.properties.customerTarget"
            [dataInizioEmissione]="planningComponent ? planningComponent.fieldModel.data_inizio_emissione : null"
            [dataFineEmissione]="planningComponent ? planningComponent.fieldModel.data_fine_emissione : null"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
              ></app-message-3-customer-target>
         </div>
     <!-- FASE 6 - Target Articoli -->
        <div class="productsTargetContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.productsTarget == false }">
            <app-message-3-products-target
            #productsTargetComponent data-testid="productsTargetComponent"
            [language]="language"
            [dateFormat]="dateFormat"
            [ui_mode]="uiModes.productsTarget"
            [coupon_mode]="coupon_mode"
            [listPaniereEmission]="paniereListEmission"

            [listDepartmentEmission]="departmentListEmission"

            [listCategoriesEmission]="categoriesListEmission"
      [listProductsEmission]="listProductsEmission"

            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [formSchema]="globalFormsSchema.properties.targetArticoli"
            [readOnly]="readOnly"
            [messageInstanceObject]="messageInstanceObject"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            ></app-message-3-products-target>
          </div>
         <!-- FASE 7 - Touchpoint -->

     <div class="touchpointContainer" *ngIf="!gestioneNuovaTouchpoint && globalFormsSchema" [ngClass]="{'formHidden': show.touchpoint == false }">
            <app-message-3-touchpoint
            #touchpointComponent data-testid="touchpointComponent"
            [language]="language"
            [actionTypeCode]="actionTypeCode"
            [actionTypesList]="actionTypesList"
            [dateFormat]="dateFormat"
            [touchpointListEmission]="touchpointListEmission"
            [ui_mode]="uiModes.touchpoint"
            [coupon_mode]="coupon_mode"
            [storeList]="storeList"
            [areeList]="areeList"
            [groupList]="groupList"
            [insegneList]="insegneList"
            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [messageInstanceObject]="messageInstanceObject"
            [readOnly]="readOnly"
            [formSchema]="globalFormsSchema.properties.touchpoint"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            ></app-message-3-touchpoint>
    </div>


     <div class="touchpointContainer" *ngIf="gestioneNuovaTouchpoint && globalFormsSchema" [ngClass]="{'formHidden': show.touchpoint == false }">
            <app-message-3-touchpoint
            #touchpointComponent data-testid="touchpointComponent"
            [language]="language"
            [dateFormat]="dateFormat"
            [touchpointListEmission]="touchpointListEmission"
            [ui_mode]="uiModes.touchpoint"
            [coupon_mode]="coupon_mode"
            [storeList]="storeList"
            [areeList]="areeList"
            [groupList]="groupList"
            [insegneList]="insegneList"
            [miObjectTypesList]="miObjectTypesList"
            [miRuleTypesList]="miRuleTypesList"
            [messageInstanceObject]="messageInstanceObject"
            [readOnly]="readOnly"
            [formSchema]="globalFormsSchema.properties.touchpoint"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            ></app-message-3-touchpoint>
    </div>

     <!-- FASE 8 - Validazioni -->
     <div class="validationsContainer" [ngClass]="{'formHidden': show.validations == false }">
            <app-message-3-validations
            #validationsComponent
            [language]="language"
            [dateFormat]="dateFormat"
            [statusList]="statusList"
            [campaignInfo]="campaignInfo"
            [actionTypeCode]="actionTypeCode"
            [statusMapping]="statusMapping"
            [touchpointListEmission]="touchpointListEmission"

            [distributionListEmission]="distributionListEmission"

            [accumulatorListEmission]="accumulatorListEmission"

            [ui_mode]="uiModes.validations"
            [coupon_mode]="coupon_mode"
            [readOnly]="readOnly"
            [messageInstanceObject]="messageInstanceObject"
            (editClicked)="onValidationEditClicked($event)"
            (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
            (formSchemaChanged)="onFormSchemaChanged($event)"

            (saveWizard)="saveSelectedWizard()"
            [miRuleTypesList]="miRuleTypesList"
            [miObjectTypesList]="miObjectTypesList"
            (unpublishCompleted)="onReloadAfterUnpublish()"
            (resetState)="onReloadAfterReset()"
            ></app-message-3-validations>
    </div>




  <div class="footerContainer">
    <br />
    <!-- Info campi obbligatori -->
    <div class="infoRequiredContainer">
      {{ 'campaign.fields_marked' | translate }} <span class="asterix">*</span> {{ 'campaign.fields_required' | translate }}
    </div>
    

    <!-- Bottoni Indietro e Conferma -->
    <div class="buttonsContainer">
      <button pButton *ngIf="currentPhaseIndex>0" (click)="onClickBackBtn()" icon="fa fa-chevron-left" iconPos="left" type="button" class="k-generic-btn footer-btn" label="{{'common.back' | translate}}"></button>
      <button pButton type="submit" [disabled]="!enable.confirmButton || readOnly==true" *ngIf="currentPhaseIndex<campaignPhases.length && (currentPhaseIndex+1)!=statusMapping.validations.number" (click)="onClickConfirmBtn()" icon="fa fa-chevron-right" iconPos="right" type="button" class="k-generic-btn footer-btn" label="{{'common.confirm' | translate}}"></button>
      <button pButton *ngIf="currentPhaseIndex+1>=statusMapping.validations.number" (click)="onClickExitBtn()" icon="fa fa-chevron-right" iconPos="right" type="button" class="k-generic-btn footer-btn" label="{{'campaign.exitButton' | translate}}"></button>
      <button *ngIf="allowSaveActionTemplate" class="star-button">
        <i class="pi pi-star" [ngClass]="{'pi-star-favourite': favouriteAction}" (click)="onSaveFavourite()"></i>
    </button>

    </div>

    <div class="clear_fix"></div>

    <br />
  </div>
  <div *ngIf="showSuccessPopup" class="success-popup">
    {{ 'campaign.action_saved_success' | translate }}
  </div>
  <div *ngIf="showSuccessDeletePopup" class="success-popup">
    {{ 'campaign.action_deleted_success' | translate }}
  </div>
  

</div>




// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/campaign-3-message.html